<template>
  <div class="main-content">
    <div class="qr-code-page">
      <div class="container">
        <div class="out-side">
          <h3 class="qr-code__title">
            請掃描報到
          </h3>
          <div class="qr-code__img">
            <CheckInQrCode
              :schedule-time-id="schedule_time_id"
              :date="date"
            ></CheckInQrCode>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckInQrCode from '@/components/QrCode/CheckInQrCode';

export default {
  data() {
    return {
      // Store the meta element
      viewport_meta: document.getElementById('viewport-meta'),
      // Define our viewport meta values
      viewports: {
        default: 'width=device-width',
        landscape: 'width=1400'
      },
      schedule_time_id: this.$route.params.schedule_time_id,
      date: this.$route.params.date
    };
  },
  components: {
    CheckInQrCode
  },
  created() {
    // 來到這個頁面,viewport設成有手機版的頁面
    this.viewportSet(this.viewport_meta, this.viewports);
  },

  beforeRouteLeave(to, from, next) {
    // 離開這個頁面,viewport設回只有電腦版寬度
    this.viewportSetWideVersion(this.viewport_meta, this.viewports);
    next();
  },
  methods: {
    viewportSet(viewport_meta, viewports) {
      //if (screen.width > 768) {
      //viewport_meta.setAttribute('content', viewports.landscape);
      //} else {
      viewport_meta.setAttribute('content', viewports.default);
      //}
    },
    viewportSetWideVersion(viewport_meta, viewports) {
      viewport_meta.setAttribute('content', viewports.landscape);
    }
  }
};
</script>
